import { Redirect, useHistory, useLocation } from "react-router-dom";

import AuthLayout, {
  AuthProviderButton,
  FormHeader,
  authProviders,
} from "components/auth/AuthLayout";
import { Link } from "react-router-dom";
import Spacer from "components/global/Spacer";
import Logo from "components/global/Logo";
import usePageTitle from "hooks/usePageTitle";
import useLegalLinks from "hooks/useLegalLinks";
import styled from "styled-components";
import axios from "axios";
import { useSelector } from "react-redux";

const AuthProviderWrapper = styled.div``;

const Register = (props) => {
  usePageTitle("Sign up");
  const router = useHistory();
  const { search } = useLocation();
  const redirectPath = new URLSearchParams(search).get("return_to");
  const postpaddyMobile = new URLSearchParams(search).get("postpaddy-mobile");
  const referralCode = new URLSearchParams(search).get("referralCode");
  const { terms, privacy } = useLegalLinks();

  const { logged_in, user_accounts, user } = useSelector((state) => ({
    logged_in: state.logged_in,
    user_accounts: state.user_accounts,
    user: state.user,
  }));

  const handleSocialAuth = async (provider) => {
    const authProviders = ["google", "apple"];
    const url = provider.target;

    if (authProviders.includes(provider.name)) {
      window.location.href = url;
      return;
    }

    if (provider.name === "email") {
      if (postpaddyMobile) {
        router.push(`/sign-up/email?postpaddy-mobile=true`);
      } else {
        router.push(`/sign-up/email${search}`);
      }
      return;
    }

    try {
      const res = await axios.get(url);
      if (res.data?.data?.redirect) {
        localStorage.setItem("redirect", redirectPath);
        localStorage.setItem("socialAuthProvider", provider.name);
        window.location.href = res.data.data.redirect;
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const redirectTo = !user?.has_viewed_tooltips?.onboarding_completed
    ? "/onboarding/create-brand"
    : !user_accounts?.length && !redirectPath?.includes("accept-invite")
    ? "/onboarding/create-brand"
    : user_accounts?.length && !redirectPath?.includes("accept-invite")
    ? redirectPath ?? "/dashboard/home"
    : "/dashboard/home";

  if (logged_in && user_accounts !== null) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <AuthLayout>
      <FormHeader>
        <Logo />
        <p className="l3">
          Already have an account?{" "}
          <Link
            to={
              redirectPath
                ? `/sign-in${search}`
                : postpaddyMobile
                ? "/sign-in?postpaddy-mobile=true"
                : "/sign-in"
            }
            className="signInText l3"
          >
            Sign in
          </Link>
        </p>
      </FormHeader>
      <Spacer y={3.2} />
      <h4 className="title">Sign up to PostPaddy</h4>
      <Spacer y={0.6} />
      <p className="l3">Let's get your account set up.</p>
      <Spacer y={2.4} />

      <AuthProviderWrapper>
        <Spacer y={2.4} yMobile={1.4} />
        {authProviders.map(
          (provider) =>
            provider.name !== "facebook" && (
              <AuthProviderButton
                key={provider.name}
                type="button"
                onClick={() => {
                  sessionStorage.setItem("referralCode", referralCode);
                  if (["facebook", "instagram"].includes(provider.name)) {
                    sessionStorage.setItem(
                      "return_to",
                      `/auth/select-channel/${provider.name}${search}`
                    );
                  } else {
                    sessionStorage.setItem("return_to", `/onboarding${search}`);
                  }
                  if (
                    !!postpaddyMobile ||
                    window.location.href.includes("postpaddy-mobile")
                  ) {
                    localStorage.setItem("authMobileProvider", "true");
                  }
                  handleSocialAuth(provider);
                }}
              >
                <img src={provider.icon} alt={provider.name} className="icon" />
                <span className="l2">{provider.buttonText}</span>
              </AuthProviderButton>
            )
        )}
      </AuthProviderWrapper>
      <Spacer y={2.4} yMobile={1.4} />
      <p className="l4 colorBodyText legal textCenter">
        By continuing, you agree to PostPaddy's{" "}
        <a href={terms} className="colorSecondary l4 textNoWrap">
          Terms of service
        </a>{" "}
        and{" "}
        <a href={privacy} className="colorSecondary l4 textNoWrap">
          Privacy policy
        </a>
        .
      </p>
    </AuthLayout>
  );
};

export default Register;
